import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postPaymentStoreOrderTransaction from './postPaymentStoreOrderTransaction';
import {
  ICreateStoreOrderTransactionPayload,
  ICreateStoreOrderTransactionResponse,
} from './types';

const usePostPaymentStoreOrderTransaction = (
  handleAfterSuccess?: (data: ICreateStoreOrderTransactionResponse) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation<
    ICreateStoreOrderTransactionResponse,
    AxiosError<IAxiosErr>,
    ICreateStoreOrderTransactionPayload
  >({
    mutationFn: postPaymentStoreOrderTransaction,
    onSuccess: data => handleAfterSuccess?.(data),
    onError: error => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostPaymentStoreOrderTransaction;
